const settingSelectors = {
  themeColor: state => state.settingReducer.themeColor,
};

export default settingSelectors;